import React, { useEffect, useState } from "react";
import TableCell, { TableCellAlignment } from "./TableCell";
import { clsx } from "clsx";

import "./TableHeaderCell.css";
import { Resizable } from "re-resizable";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";

interface TableHeaderCellProps {
    width?: number;
    columnKey?: string;
    widthConstraints?: {
        min: number;
        max: number;
    };
    alignment?: TableCellAlignment;
    direction?: "asc" | "desc" | null;
    onClick?: () => void;
    onResize?: (width: number) => void;
    className?: string;
}

const TableHeaderCell: React.FC<React.PropsWithChildren<TableHeaderCellProps>> = ({
    alignment = TableCellAlignment.left,
    width = null,
    columnKey,
    ...props
}) => {
    const [resizableWidth, setResizableWidth] = useState(width);
    const [isResizing, setIsResizing] = useState(false);

    useEffect(() => {
        if (width !== resizableWidth) {
            setTimeout(() => props.onResize?.(resizableWidth), 0);
        }
    }, [width, resizableWidth]);

    // if (props.direction) {
    //     console.log({ columnKey, resizableWidth, width });
    // }

    let content = (
        <div onClick={() => props.onClick?.()}>
            <span style={props.onClick ? { cursor: "pointer" } : undefined}>{props.children}</span>
            <span className={"Table__HeaderCell__SortingArrow"}>
                {props.direction === "asc" && <ArrowUpOutlined />}
                {props.direction === "desc" && <ArrowDownOutlined />}
            </span>
        </div>
    );

    if (props.onResize) {
        const c = props.widthConstraints || {
            min: 20,
            max: 10000,
        };
        content = (
            <Resizable
                size={{
                    width: resizableWidth,
                    height: 28,
                }}
                onResizeStop={(e, direction, ref, d) => {
                    setResizableWidth(prevState => {
                        const newState = prevState + d.width;
                        if (newState < c.min) {
                            return c.min;
                        }
                        if (newState > c.max) {
                            return c.max;
                        }
                        // console.log({ newState, prevState, d });
                        return newState;
                    });
                    setTimeout(() => setIsResizing(false), 100);
                }}
                onResizeStart={() => setIsResizing(true)}
                className="resizable"
                enable={{
                    top: false,
                    right: true,
                    bottom: false,
                    left: false,
                    topRight: false,
                    bottomRight: false,
                    bottomLeft: false,
                    topLeft: false,
                }}
                minWidth={c.min}
                maxWidth={Math.max(c.max, resizableWidth)}
                handleClasses={{
                    right: "react-resizable-handle",
                }}
            >
                {content}
            </Resizable>
        );
    }
    return (
        <TableCell
            headerTag
            width={width}
            alignment={alignment}
            className={clsx(props.className, {
                Table__HeaderCell: true,
                "Table__HeaderCell--sorted": !!props.direction,
                "Table__HeaderCell--resizing": isResizing,
            })}
        >
            {content}
        </TableCell>
    );
};

export default React.memo(TableHeaderCell);
